
import Home from '../pages/home/page';
import Articles from '../pages/articles/page';
import ArticleDetail from '../pages/article-detail/page';
import { LegacyArticleDetailRedirect } from './LegacyArticleRedirect';
import Diagnosis from '../pages/diagnosis/page';
import DiagnosisResult from '../pages/diagnosis-result/page';
import DiagnosisResult2 from '../pages/diagnosis-result2/page';
import DiagnosisResult3 from '../pages/diagnosis-result3/page';
import DiagnosisResult4 from '../pages/diagnosis-result4/page';
import DiagnosisResult5 from '../pages/diagnosis-result5/page';
import DiagnosisResult6 from '../pages/diagnosis-result6/page';
import DiagnosisResult7 from '../pages/diagnosis-result7/page';
import DiagnosisResult8 from '../pages/diagnosis-result8/page';
import DiagnosisResult9 from '../pages/diagnosis-result9/page';
import DiagnosisResult10 from '../pages/diagnosis-result10/page';
import DiagnosisResult11 from '../pages/diagnosis-result11/page';
import DiagnosisResult12 from '../pages/diagnosis-result12/page';
import DiagnosisResult13 from '../pages/diagnosis-result13/page';
import DiagnosisResult14 from '../pages/diagnosis-result14/page';
import DiagnosisResult15 from '../pages/diagnosis-result15/page';
import DiagnosisResult16 from '../pages/diagnosis-result16/page';
import DiagnosisResult17 from '../pages/diagnosis-result17/page';
import Admin from '../pages/admin/page';
import AdminGate from '../pages/admin/AdminGate';
import { ADMIN_PAGE_PATH } from '../constants/adminRoute';
import Terms from '../pages/terms/page';
import Privacy from '../pages/privacy/page';
import Contact from '../pages/contact/page';
import NotFound from '../pages/NotFound';

const routes = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/articles/:id',
    element: <ArticleDetail />,
  },
  {
    path: '/articles',
    element: <Articles />,
  },
  {
    path: '/article-detail/:id',
    element: <LegacyArticleDetailRedirect />,
  },
  {
    path: '/article-detail',
    element: <LegacyArticleDetailRedirect />,
  },
  {
    path: '/diagnosis',
    element: <Diagnosis />,
  },
  {
    path: '/diagnosis-result',
    element: <DiagnosisResult />,
  },
  {
    path: '/diagnosis-result2',
    element: <DiagnosisResult2 />,
  },
  {
    path: '/diagnosis-result3',
    element: <DiagnosisResult3 />,
  },
  {
    path: '/diagnosis-result4',
    element: <DiagnosisResult4 />,
  },
  {
    path: '/diagnosis-result5',
    element: <DiagnosisResult5 />,
  },
  {
    path: '/diagnosis-result6',
    element: <DiagnosisResult6 />,
  },
  {
    path: '/diagnosis-result7',
    element: <DiagnosisResult7 />,
  },
  {
    path: '/diagnosis-result8',
    element: <DiagnosisResult8 />,
  },
  {
    path: '/diagnosis-result9',
    element: <DiagnosisResult9 />,
  },
  {
    path: '/diagnosis-result10',
    element: <DiagnosisResult10 />,
  },
  {
    path: '/diagnosis-result11',
    element: <DiagnosisResult11 />,
  },
  {
    path: '/diagnosis-result12',
    element: <DiagnosisResult12 />,
  },
  {
    path: '/diagnosis-result13',
    element: <DiagnosisResult13 />,
  },
  {
    path: '/diagnosis-result14',
    element: <DiagnosisResult14 />,
  },
  {
    path: '/diagnosis-result15',
    element: <DiagnosisResult15 />,
  },
  {
    path: '/diagnosis-result16',
    element: <DiagnosisResult16 />,
  },
  {
    path: '/diagnosis-result17',
    element: <DiagnosisResult17 />,
  },
  {
    path: '/admin',
    element: <NotFound />,
  },
  {
    path: `/${ADMIN_PAGE_PATH}`,
    element: (
      <AdminGate>
        <Admin />
      </AdminGate>
    ),
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
